const moreThanOneWord = (value) => {
  if (!value) {
    return false;
  }
  const words = value.split(' ');
  const nonEmptyWords = words.filter((word) => word.length > 0);
  return nonEmptyWords.length > 1;
};

export default moreThanOneWord;
